module.exports = function() {
  return new Worker(__webpack_public_path__ + "c4bb144064c6bf45cadf.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ../gateway-client-proxy/src/client/proxy/GatewayClientWorker.js
// module id = 2193
// module chunks = 2